/** AI判定ラベル(建物) */
export const AI_LABEL_BUILDING = {
  /** 非全壊 */
  notCollapsed: '00',
  /** 全壊 */
  collapsed: '10'
} as const

/** AI判定ラベル(建物) 型定義 */
export type AiLabelBuilding = (typeof AI_LABEL_BUILDING)[keyof typeof AI_LABEL_BUILDING]
